(() => {
  if (window.__figCartConfirmationInstalled) return;

  const init = () => {
    const notification = document.getElementById('FigCartConfirmation');
    if (!notification || window.__figCartConfirmationInstalled) return;

    window.__figCartConfirmationInstalled = true;

    const productElement = notification.querySelector('.fig-cart-notification__product');
    const imageElement = notification.querySelector('[data-fig-cart-image]');
    const imageWrap = notification.querySelector('[data-fig-cart-image-wrap]');
    const titleElement = notification.querySelector('[data-fig-cart-title]');
    const variantElement = notification.querySelector('[data-fig-cart-variant]');
    const quantityElement = notification.querySelector('[data-fig-cart-quantity]');
    const priceElement = notification.querySelector('[data-fig-cart-price]');
    const totalElement = notification.querySelector('[data-fig-cart-total]');
    const summaryElement = notification.querySelector('[data-fig-cart-summary]');
    const timerElement = notification.querySelector('[data-fig-cart-timer]');
    const originalFetch = window.fetch.bind(window);
    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = `${root}cart`;
    const AUTO_CLOSE_MS = 7000;

    let closeTimer = null;
    let lastSignature = '';
    let lastOpenTime = 0;

    const formatMoney = (cents) => {
      if (typeof cents !== 'number') return '';
      return new Intl.NumberFormat('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100) + ' lei';
    };

    const normalizeImageUrl = (value) => {
      let url = value;
      if (url && typeof url === 'object') url = url.url || url.src || '';
      if (!url) return '';
      return url.startsWith('//') ? `https:${url}` : url;
    };

    const getAddedItem = (data) => {
      if (!data) return null;
      if (Array.isArray(data.items) && data.items.length) return data.items[data.items.length - 1];
      return data.product_title || data.title || data.variant_title ? data : null;
    };

    const getCart = async () => {
      try {
        const response = await originalFetch(`${cartUrl}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        return response.ok ? response.json() : null;
      } catch (error) {
        return null;
      }
    };

    const setPosition = () => {
      /* Poziția aparține viewport-ului, nu headerului care se mișcă la scroll. */
      const isMobile = matchMedia('(max-width: 749px)').matches;
      notification.style.setProperty('--fig-cart-top', isMobile ? '14px' : '82px');
      notification.style.setProperty(
        '--fig-cart-right',
        isMobile ? '14px' : 'max(28px, calc((100vw - 1400px) / 2 + 20px))'
      );
    };

    const close = () => {
      clearTimeout(closeTimer);
      closeTimer = null;
      if (notification.hidden || notification.classList.contains('is-closing')) return;
      notification.classList.add('is-closing');
      setTimeout(() => {
        notification.hidden = true;
        notification.classList.remove('is-closing');
      }, 180);
    };

    const startTimer = () => {
      clearTimeout(closeTimer);
      if (timerElement) {
        timerElement.style.animation = 'none';
        void timerElement.offsetWidth;
        timerElement.style.animation = '';
      }
      closeTimer = setTimeout(close, AUTO_CLOSE_MS);
    };

    const open = (item, cart) => {
      if (!item) return;

      const productTitle = item.product_title || item.title || item.name || 'Produs FigurinArt';
      const signature = `${item.key || item.id || item.variant_id || productTitle}:${item.quantity || 1}`;
      const now = Date.now();
      if (signature === lastSignature && now - lastOpenTime < 700) return;
      lastSignature = signature;
      lastOpenTime = now;

      const variantTitle = item.variant_title || '';
      const showVariant = variantTitle && variantTitle !== 'Default Title';
      const imageUrl = normalizeImageUrl(item.featured_image || item.image || item.featured_media?.preview_image);
      const price = typeof item.final_price === 'number' ? item.final_price : item.price;
      const cartCount = typeof cart?.item_count === 'number' ? cart.item_count : null;

      titleElement.textContent = productTitle;
      quantityElement.textContent = item.quantity || 1;
      priceElement.textContent = formatMoney(price);
      totalElement.textContent = cart ? formatMoney(cart.total_price) : '';
      summaryElement.textContent = cartCount === null
        ? 'Produsul a fost adăugat'
        : cartCount === 1 ? 'Ai 1 produs în coș' : `Ai ${cartCount} produse în coș`;

      variantElement.textContent = showVariant ? variantTitle : '';
      variantElement.hidden = !showVariant;

      if (imageUrl) {
        imageElement.src = imageUrl;
        imageElement.alt = productTitle;
        imageElement.hidden = false;
        imageWrap.hidden = false;
        productElement.classList.remove('is-without-image');
      } else {
        imageElement.removeAttribute('src');
        imageElement.hidden = true;
        imageWrap.hidden = true;
        productElement.classList.add('is-without-image');
      }

      setPosition();
      notification.classList.remove('is-closing');
      notification.hidden = false;
      startTimer();
    };

    const showData = async (data) => {
      const item = getAddedItem(data);
      if (!item) return;
      open(item, await getCart());
    };

    notification.querySelectorAll('[data-fig-cart-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !notification.hidden) close();
    });

    addEventListener('resize', () => {
      if (!notification.hidden) setPosition();
    }, { passive: true });

    document.addEventListener('cart:updated', (event) => {
      const detail = event.detail || {};
      const data = detail.product || detail.item || detail.addedItem;
      if (data) setTimeout(() => showData(data), 30);
    });

    const addCarouselProduct = async (form) => {
      const button = form.querySelector('[data-fs-add-button]');
      if (!button || button.disabled || button.dataset.figAdding === 'true') return;

      const label = button.querySelector('[data-fs-add-label]');
      const originalLabel = label?.textContent || '';
      button.dataset.figAdding = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Se adaugă…';

      try {
        const response = await originalFetch(`${cartUrl}/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Produsul nu a putut fi adăugat.');

        if (label) label.textContent = 'Adăugat în coș ✓';
        button.classList.add('is-added');
        await showData(result);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { product: result } }));

        setTimeout(() => {
          button.classList.remove('is-added');
          if (label) label.textContent = originalLabel || 'Adaugă în coș';
        }, 2200);
      } catch (error) {
        if (label) label.textContent = error.message || 'Încearcă din nou';
      } finally {
        button.dataset.figAdding = 'false';
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };

    /* Window capture runs before Savor's document/section listeners, including
       buttons inserted later when a carousel is rebuilt. */
    window.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-fs-add-button]');
      if (!button) return;
      const form = button.closest('[data-fs-add-form]');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addCarouselProduct(form);
    }, true);

    window.addEventListener('submit', (event) => {
      const form = event.target.closest?.('[data-fs-add-form]');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addCarouselProduct(form);
    }, true);

    window.fetch = async (...args) => {
      const input = args[0];
      const options = args[1] || {};
      const requestUrl = typeof input === 'string' ? input : input?.url || String(input || '');
      const method = (options.method || input?.method || 'GET').toUpperCase();
      let pathname = requestUrl;
      try { pathname = new URL(requestUrl, location.origin).pathname; } catch (error) {}
      const isAdd = method === 'POST' && /\/cart\/add(?:\.js)?\/?$/.test(pathname);
      const response = await originalFetch(...args);

      if (isAdd && response.ok) {
        response.clone().json().then((data) => setTimeout(() => showData(data), 80)).catch(() => {});
      }
      return response;
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
